module.exports = __webpack_public_path__ + "img/a9eeff1.jpg";